import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=654f05e4&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=654f05e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports